/**
 * @file embed-map-hover.tsx
 * @module EmbedMapHover
 * @description Virzīšanās (hover) apstrādātājs iegultajai kartei. Parāda padomu/pārklājumu,
 *              kad lietotājs virza peli virs atbalstītu objektu tipiem (sensori, kameras, UVIS).
 *              Pārvalda Mapbox GL uznirstošā loga pozicionēšanu un objektu izcēluma stāvokli.
 */

import { useContext, useEffect, useRef } from "react";
import { EmbedMapContext } from "../embed-map/embed-map";
import { MapGeoJSONFeature, MapMouseEvent } from "maplibre-gl";

/**
 * Headless component that handles mouse hover interactions on the embed map.
 * Sets the cursor to "pointer" when hovering over data features to indicate
 * clickability. Feature-state-based highlighting is available but disabled.
 */
export default function EmbedMapHover() {
	const { map } = useContext(EmbedMapContext);
	const highlightedFeature = useRef<MapGeoJSONFeature>();

	useEffect(() => {
		if (!map) return;

		const onMove = (e: MapMouseEvent) => {
			const [feature] = map.queryRenderedFeatures(e.point).filter((f) => f.layer.source !== "openmaptiles");

			if (feature && feature.id) {
				map.getCanvas().style.cursor = "pointer";
			} else {
				map.getCanvas().style.cursor = "";
			}
		};

		map.on("mousemove", onMove);

		return () => {
			map.off("mousemove", onMove);
		};
	}, [map]);

	return <></>;
}
